import { Trans, useLingui } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import Button from '@/design_system/Button';
import FoldableSection from '@/design_system/FoldableSection';
import Tooltip from '@/design_system/Tooltip';
import Title from '@/design_system/Typography/Title';
import IconInfo from '@/icons/Info.svg';
import { RequestComments } from '@/routes/Requests/Request/components/RequestComments';
import { ErrorBoundary } from '@/services/sentry';
import useViewPort from '@/utils/useViewport';

export const CommentsSection = ({
  articleId,
  requestId,
}: {
  articleId: string;
  requestId: string;
}) => {
  const { t } = useLingui();
  const { isMobile } = useViewPort();

  return (
    <FoldableSection
      label={
        <Title as="h2">
          <Trans id="article.comment.title">Item comments</Trans>
        </Title>
      }
      labelOutsideButton={
        <Tooltip
          content={t({
            id: 'comments.title.tooltip',
            message: "These comments won't be visible by the client",
          })}
        >
          <Button variant="style-less">
            <IconInfo className="text-disabled" style={{ fontSize: '1.25rem' }} />
          </Button>
        </Tooltip>
      }
    >
      <ErrorBoundary>
        <Box padding="0" className={isMobile ? undefined : 'bg-neutral-0'} removeStyleOnMobile>
          <RequestComments requestId={requestId} articleId={articleId} />
        </Box>
      </ErrorBoundary>
    </FoldableSection>
  );
};
